import { Maybe } from 'maybe-not';
import MessageBus from 'q2-tecton-common/lib/utility/message-bus';

export default function cdnOverrideSetup(messageBus: MessageBus, capabilities: Set<string>) {
    if (!capabilities.has('cdnOverride')) {
        return;
    }

    return function cdnOverride() {
        return messageBus
            .sendRequest<{ path: string }>('cdnOverride', Maybe.nothing<string>())
            .then(response => {
                return response.value.path;
            });
    };
}
